export const en_messages = {
    // 'total_amount': 'Общая сумма',
    // 'deals': 'Сделки',
    
}